import { createAction } from '@reduxjs/toolkit';

export const populatePayer = createAction('[MedicalNecessity] populatePayer');
